import React from "react";
import DepChart from "./departure-chart";
import ReactTooltip from "react-tooltip";

export default class PtResults extends React.Component {
  render() {
    var ptdata = this.props.ptquali;
    if (ptdata === null) {
      return (
        <div className="oevqualidiv text-center">
          <div className="bold">ÖV-Qualität</div>
          <div className={"pubstransquali-indicator pubstransquali-low"}>
            Keine
          </div>
          <div className="bold">Beste Haltestelle</div>
          <div>-</div>
          <div className="bold">Abfahrtsintervall</div>
          <div>-</div>
          <div className="bold">Bahnanbindung</div>
          <div>-</div>
        </div>
      );
    }
    var qualicolorclassname;
    if (ptdata.quality === "Gering") {
      qualicolorclassname = "pubstransquali-low";
    }
    if (ptdata.quality === "Mittel") {
      qualicolorclassname = "pubstransquali-medium";
    }
    if (ptdata.quality === "Hoch") {
      qualicolorclassname = "pubstransquali-high";
    }

    function showTrainData() {
      if (ptdata.trainStation !== null) {
        return (
          <div className="train-station-desc">
	  <hr></hr>
            {ptdata.trainStation.type === "tram_station" ? (
              <div className="bold">Straßenbahnhaltestelle</div>
            ) : (
              <div className="bold">Bahnhaltestelle</div>
            )}
            <div>
              in ca. {Math.round(ptdata.trainStation.walk_to_station.walk_time)}{" "}
              Min. Gehzeit
            </div>
            <div>({ptdata.trainStation.walk_to_station.name})</div>
            <div className="bold">Abfahrtsintervall</div>
            <div>
              ca. {Math.round(ptdata.trainStation.frq_data.frequency_train)} Min.
            </div>
	    <div className="dep-chart text-center center-block">
	<DepChart departures={ptdata.trainStation.frq_data.deps_train} color={"rgba(49, 151, 216,0.8)"}></DepChart>
	</div>
          </div>
        );
      } else {
        return <div>Keine Bahnhaltstelle in 15 Min.</div>;
      }
    }

    return (
      <div className="oevqualidiv text-center center-block">
        <ReactTooltip />
        <div className="bold">
          ÖV-Qualität{" "}
          <span
            className="tooltip-icon"
            data-tip="...wird anhand der Gehzeit zur Haltestelle, der Abfahrtsdichte der Verkehrsmittel und dem Vorhandensein einer Bahnhaltestelle bestimmt."
          >
            [?]
          </span>
        </div>
        <div className={"pubstransquali-indicator " + qualicolorclassname}>
          {ptdata.quality}
        </div>
        <div className="bold">Nächste ÖV-Haltestelle</div>
        <div>
          in ca. {Math.round(ptdata.nextStation.walk_to_station.walk_time)} Min.
          Gehzeit
        </div>
        <div>({ptdata.nextStation.walk_to_station.name})</div>
        <div className="bold">Abfahrtsintervall am Morgen</div>
        <div>ca. {Math.round(ptdata.nextStation.frq_data.frequency)} Min.</div>
	<div className="bold">Verteilung nach Tageszeit <span
            className="tooltip-icon"
            data-tip="...inkludiert alle Verkehrsmittel (je nach Haltestelle Bus und/oder Bahn) in eine Fahrtrichtung (Montag; aktueller Fahrplan)"
          >
            [?]
          </span>:</div>
	<div className="dep-chart text-center center-block">
	<DepChart departures={ptdata.nextStation.frq_data.deps} color={"rgba(216, 49, 49,0.8)"}></DepChart>
	</div>
        {showTrainData()}
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/react_components/livingplaceprocess/infraresults/ptresult.js